import WindowTemplate from '../../WindowTemplate/windowTemplate';

const grid = `"filter filter filter filter"
              "capTitle capTitle revTitle revTitle"
              "progress progress rev1 rev1"
              "progress progress rev2 rev2"
              "cap1 cap1 rev3 rev3"
              "board board board board"`;

const settings = [
    {gridArea: 'filter', width: '100%', height: '32px'},
    {gridArea: 'capTitle', width: '70%', height: '20px'},
    {gridArea: 'revTitle', width: '70%', height: '20px'},
    {gridArea: 'progress', width: '90px', height: '90px', moreStyle: {'border-radius': '50%'}},
    {gridArea: 'rev1', width: '90%', height: '18px'},
    {gridArea: 'rev2', width: '90%', height: '18px'},
    {gridArea: 'rev3', width: '90%', height: '18px'},
    {gridArea: 'cap1', width: '60%', height: '18px'},
    {gridArea: 'board', width: '100%', height: '290px', moreStyle: {'border-radius': '20px'}}
];

function TimetableSalesTemplate() {
    return <WindowTemplate gridAreas={grid} settings={settings} gridMoreStyle={undefined} />;
}
export default TimetableSalesTemplate;
